import { AlertTriangle } from "lucide-react";

interface SuspendedBannerProps {
  status: string;
}

/**
 * Full-width warning banner shown when an organization's subscription
 * is suspended (past_due / canceled / paused).
 * Renders above the main content area, does NOT block navigation
 * so admins can still reach billing settings.
 */
export function SuspendedBanner({ status }: SuspendedBannerProps) {
  const messages: Record<string, string> = {
    past_due:
      "Your subscription payment is past due. Some features may be restricted until payment is resolved.",
    canceled:
      "Your subscription has been canceled. Please contact your administrator to reactivate.",
    paused:
      "Your subscription is currently paused. Please contact your administrator to resume service.",
  };

  const message = messages[status] ?? messages.canceled;

  return (
    <div className="suspended-banner" role="alert">
      <AlertTriangle size={18} />
      <span>{message}</span>
    </div>
  );
}
